import { Outlet } from 'react-router-dom'

const Agents = () => {
  return (
    <Outlet />
  )
}

export default Agents
